<script setup>
// core
import {computed, getCurrentInstance, ref} from "vue";
import {useStore} from "vuex";

// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";
import CallNumberView from "@/components/Telephony/CallNumberView.vue";

const {proxy} = getCurrentInstance()
const store = useStore()
const isLoading = ref(false)

const currentExtension = computed(() => store.state.dialogParams?.currentExtension)
const number = computed(() => store.state.dialogParams?.info?.number)

const onDelete = async () => {
    const username = currentExtension.value?.credentials?.username
    if (!username) return

    isLoading.value = true

    try {
        await store.dispatch('telephony/deleteExtension', {
            username,
            number: number.value,
            moshaToast: proxy.$moshaToast,
        })

        if (!!store.getters.getNextDialog) {
            store.commit("setDialog", store.getters.getNextDialog);
            store.commit("setNextDialog", "");
        } else {
            store.commit("closeDialog");
        }
    } finally {
        isLoading.value = false
    }
}
</script>

<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">
            {{ $t('telephony.sip.delete.title') }}
            <div class="number-block">
                <CallNumberView :number="number"/>
            </div>
        </h3>

        <div class="content">
            <i18n-t keypath="telephony.sip.delete.confirm" tag="p" class="confirm">
                <template #name>
                    <span class="value">{{ currentExtension?.name }}</span>
                </template>
            </i18n-t>

            <div class="action_container">
                <ButtonLoading :loading="isLoading" @click="onDelete">
                    {{ $t('common.delete') }}
                </ButtonLoading>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
